import { Chip, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { updateGlobalSearchQuery, updateGlobalSearchResultCleared } from 'slice/searchSlice';

export default function ChipsList({ tags, onChipClicked, clickable, ...props }) {
  const dispatch = useDispatch();
  const handleChipClick =
    onChipClicked ??
    ((label) => {
      dispatch(updateGlobalSearchResultCleared(true));
      dispatch(updateGlobalSearchQuery(label));
    });
  return (
    <Grid container direction="row" rowSpacing={1} columnSpacing={1} {...props}>
      {tags &&
        tags.map((term, index) => (
          <Grid item key={index}>
            {clickable ? (
              <Chip key={index} label={term.label} onClick={() => handleChipClick(term.label)} />
            ) : (
              <Chip key={index} label={term.label} />
            )}
          </Grid>
        ))}
    </Grid>
  );
}

ChipsList.defaultValue = {
  clickable: true
};

ChipsList.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      count: PropTypes.number
    })
  ),
  onChipClicked: PropTypes.func,
  clickable: PropTypes.bool
};
